$(document).ready(function(){
 $('.testimonialslide').slick({
  centerMode: true,
  // centerPadding: '450px',
  slidesToShow: 1,
  dots: false,
  prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
  responsive: [
    {
      breakpoint: 1940,
      settings: {
        arrows: true,
        centerPadding: '450px',
        centerMode: true,
        slidesToShow: 1,
        dots: false,
        prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
      }
    },
    {
      breakpoint: 1440,
      settings: {
        arrows: true,
        centerPadding: '450px',
        centerMode: true,
        slidesToShow: 1,
        dots: false,
        prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
      }
    },
    {
      breakpoint: 1240,
      settings: {
        arrows: true,
        centerPadding: '450px',
        centerMode: true,
        slidesToShow: 1,
        dots: false,
        prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
      }
    },
    {
      breakpoint: 1140,
      settings: {
        arrows: true,
        centerPadding: '40px',
        centerMode: true,
        slidesToShow: 1,
        dots: false,
        prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
      }
    },
    {
      breakpoint: 1024,
      settings: {
        arrows: true,
        centerPadding: '40px',
        centerMode: true,
        slidesToShow: 1,
        dots: false,
        prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0582/4207/2599/files/arrow-left.svg?v=1702542682"></button>',
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '10px',
        slidesToShow: 1,
        dots: true
      }
    }
  ]
});
});